// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__24ieW","header":"PatientQuestionnaire_header__1njuB","info":"PatientQuestionnaire_info__1k_84"};